import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useMount } from './use-mount'
import { notifyBugsnag } from '../helpers/bugsnag'
import {
  FALLBACK_LANGUAGE,
  getSupportedLanguage,
  isLanguageSupported
} from '../helpers/languages'

export const useI18n = () => {
  const { i18n } = useTranslation()

  const [currentLang, setCurrentLang] = useState(null)

  useMount(() => {
    const getActiveLanguage = () => {
      try {
        const searchParams = new URLSearchParams(document.location.search)
        const languageFromUrl = searchParams.get('language')

        // unbekannte Sprache im Link ignorieren, sonst zeigt die Seite rohe Keys
        if (isLanguageSupported(languageFromUrl)) {
          return getSupportedLanguage(languageFromUrl)
        }

        // browser / device language
        const navigatorLanguage = navigator.language
        if (isLanguageSupported(navigatorLanguage)) {
          return getSupportedLanguage(navigatorLanguage)
        }
      } catch (err) {
        notifyBugsnag(err)
      }

      return FALLBACK_LANGUAGE
    }

    const language = getActiveLanguage()

    setCurrentLang(language)
    i18n.changeLanguage(language)
  })

  return { language: currentLang }
}
